/* =====================================================================
   BB05 · Walk Kit Sales PDP — saleskitbb05-page.js
   Handles: gallery thumbs, pack/color/size selection (variant lookup),
   name patch input, accordions, ATC.
   All actions live inside .saleskitbb05-scope; no global pollution.
   ===================================================================== */
(function () {
  if (window.__saleskitbb05Init) return;
  window.__saleskitbb05Init = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ---- Helpers --------------------------------------------------------
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoneyCents(cents, currency) {
    var n = (cents / 100).toFixed(2);
    var sym = '$';
    if (currency === 'AUD') sym = 'A$';
    return sym + n;
  }

  // ---- Per-PDP-section state -----------------------------------------
  function initPdp(scope) {
    var dataEl = $('[data-saleskitbb05-product]', scope);
    if (!dataEl) return;
    var product = {};
    try { product = JSON.parse(dataEl.textContent || '{}'); } catch (e) { product = {}; }

    var variants = product.variants || [];
    var optionNames = product.option_names || ['Pack', 'Colour', 'Size'];
    var currency = product.currency || 'AUD';
    var productImages = product.images || []; // [{id, position}, ...]
    var imageIdToIndex = {};
    productImages.forEach(function (im) { imageIdToIndex[im.id] = im.position; });

    // Helper: change main image to the one matching a featured_image_id from a variant
    function setSlideByImageId(imageId) {
      if (!imageId) return;
      var idx = imageIdToIndex[imageId];
      if (typeof idx === 'undefined') return;
      var thumbs = $$('.saleskitbb05-gallery__thumb', scope);
      var mainImg = $('.saleskitbb05-gallery__main img', scope);
      if (!thumbs[idx] || !mainImg) return;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumbs[idx].classList.add('is-active');
      var src = thumbs[idx].dataset.saleskitbb05Src || (thumbs[idx].querySelector('img') && thumbs[idx].querySelector('img').src);
      if (src) {
        mainImg.style.opacity = '0';
        setTimeout(function () { mainImg.src = src; mainImg.style.opacity = '1'; }, 120);
      }
      // Horizontal-only scroll the thumbs strip — DO NOT use scrollIntoView (jumps page vertically on mobile)
      var thumbsCont = $('.saleskitbb05-gallery__thumbs', scope);
      if (thumbsCont && thumbs[idx]) {
        var btnRect = thumbs[idx].getBoundingClientRect();
        var contRect = thumbsCont.getBoundingClientRect();
        var deltaX = (btnRect.left - contRect.left) - (contRect.width - btnRect.width) / 2;
        thumbsCont.scrollTo({ left: thumbsCont.scrollLeft + deltaX, behavior: 'smooth' });
      }
    }

    // selected[] is indexed by ACTUAL option names from the product (e.g. "Color" or "Colour")
    // optionNames may be objects or strings depending on Shopify version.
    var optNameStrings = optionNames.map(function (n) { return (typeof n === 'string') ? n : (n && n.name) ? n.name : String(n); });
    var selected = {};
    optNameStrings.forEach(function (n) { selected[n] = null; });
    var currentVariant = null;

    // Try to seed with default = Black variant (if available), else first available variant.
    // Color option detection: look for a name matching /colou?r|color|colore|farbe/i.
    if (variants.length) {
      var colorIdx = -1;
      for (var ci = 0; ci < optNameStrings.length; ci++) {
        if (/colou?r|color|colore|farbe|negro/i.test(optNameStrings[ci])) { colorIdx = ci; break; }
      }
      var preferred = null;
      if (colorIdx >= 0) {
        preferred = variants.find(function (v) {
          var val = v.options[colorIdx];
          return v.available && val && /^\s*(black|negro|noir|schwarz|nero)\s*$/i.test(String(val));
        });
      }
      var first = preferred
        || variants.find(function (v) { return v.available; })
        || variants[0];
      optNameStrings.forEach(function (n, idx) { selected[n] = first.options[idx] || null; });
    }

    function findVariantBySelection() {
      if (!variants.length) return null;
      return variants.find(function (v) {
        for (var i = 0; i < optNameStrings.length; i++) {
          if (v.options[i] !== selected[optNameStrings[i]]) return false;
        }
        return true;
      }) || null;
    }

    function updateActive(group, value) {
      $$('[data-saleskitbb05-option="' + group + '"]', scope).forEach(function (el) {
        if (el.dataset.saleskitbb05Value === value) el.classList.add('is-active');
        else el.classList.remove('is-active');
      });
      var label = $('[data-saleskitbb05-selected="' + group + '"]', scope);
      if (label) label.textContent = value;
    }

    function refreshCta() {
      var cta = $('[data-saleskitbb05-cta]', scope);
      currentVariant = findVariantBySelection();

      if (cta) {
        var label = cta.dataset.saleskitbb05CtaLabel || 'Add to cart';
        if (currentVariant) {
          cta.dataset.saleskitbb05VariantId = String(currentVariant.id);
          cta.disabled = !currentVariant.available;
          cta.textContent = (currentVariant.available ? label : 'Sold out')
            + (currentVariant.available ? ' — ' + formatMoneyCents(currentVariant.price, currency) : '');
        } else {
          var fallbackCents = parseInt(cta.dataset.saleskitbb05Fallback || '0', 10);
          cta.disabled = false;
          cta.textContent = label + (fallbackCents ? ' — ' + formatMoneyCents(fallbackCents, currency) : '');
        }
      }

      if (currentVariant) {
        // Change gallery image to variant's featured_image
        if (currentVariant.featured_image_url) {
          var mainImg = $('.saleskitbb05-gallery__main img', scope);
          if (mainImg && mainImg.src !== currentVariant.featured_image_url) {
            mainImg.style.opacity = '0';
            setTimeout(function () { mainImg.src = currentVariant.featured_image_url; mainImg.style.opacity = '1'; }, 120);
          }
          // Also activate matching thumb
          if (currentVariant.featured_image_id) setSlideByImageId(currentVariant.featured_image_id);
        } else if (currentVariant.featured_image_id) {
          setSlideByImageId(currentVariant.featured_image_id);
        }

        // Update price-now
        var priceNow = $('[data-saleskitbb05-price-now]', scope);
        if (priceNow) priceNow.textContent = formatMoneyCents(currentVariant.price, currency);

        // Update price-was (compare_at_price) — show only if higher than current price
        var priceOld = $('[data-saleskitbb05-price-old]', scope);
        var discountEl = $('[data-saleskitbb05-discount]', scope);
        if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
          if (priceOld) {
            priceOld.textContent = formatMoneyCents(currentVariant.compare_at_price, currency);
            priceOld.removeAttribute('hidden');
            priceOld.style.display = '';
          }
          // Compute numeric SAVE — compare_at_price - price (in cents → money)
          if (discountEl) {
            var savedCents = currentVariant.compare_at_price - currentVariant.price;
            var prefix = (discountEl.dataset.saleskitbb05DiscountPrefix || 'SAVE').trim();
            discountEl.textContent = prefix + ' ' + formatMoneyCents(savedCents, currency);
            discountEl.removeAttribute('hidden');
            discountEl.style.display = '';
          }
        } else {
          if (priceOld) {
            priceOld.setAttribute('hidden', '');
            priceOld.style.display = 'none';
          }
          if (discountEl) {
            discountEl.setAttribute('hidden', '');
            discountEl.style.display = 'none';
          }
        }
      }

      refreshPackCardsPrices();
      refreshNamepatchMode();
      refreshSizesVisibility();
      refreshNamePatchBadge();
      refreshNamePatchAddonCard();
      refreshNamePatchTwin();
      applyAddonToDisplay();
    }

    // Swap the right-side badge inside .saleskitbb05-namepatch__label-row depending on selected pack.
    // No-Pull Harness → red 'ADD-ON +A$14.90'.  Walk Kit / Twin Pack → green '✓ INCLUDED IN YOUR PACK'.
    var BB05_NAMEPATCH_BADGE = {
      addonPack: 'No-Pull Harness',
      addonText: 'ADD-ON +A$14.90',
      includedText: 'INCLUDED IN YOUR PACK'
    };
    // === Name patch ADD-ON config (used when pack = addonPack and user typed a name) ===
    // To CHARGE the +A$14.90 at checkout, create a separate Shopify product and paste its
    // variant ID into addonVariantId. Without it, the +A$14.90 is visual-only and the
    // cart line item is just the harness with `Name patch: REX` as a property.
    var BB05_NAMEPATCH_ADDON = {
      cents: 1490,                                // A$14.90 in cents
      addonVariantId: '45919678431418'            // Shopify variant ID of 'Name Patch Add-on' product
    };

    var BB05_TWIN = {
      pack: 'Twin Pack',
      placeholder1: "Type the first pup's name…",
      placeholder2: "Type the second pup's name…"
    };

    // Inject a second name patch input (hidden by default). Shows only when pack = Twin Pack.
    (function ensureTwinInput() {
      var firstInput = $('[data-saleskitbb05-namepatch]', scope);
      if (!firstInput) return;
      if ($('[data-saleskitbb05-namepatch-2]', scope)) return;  // already there
      var second = document.createElement('input');
      second.className = 'saleskitbb05-namepatch__input';
      second.type = 'text';
      second.maxLength = 12;
      second.placeholder = BB05_TWIN.placeholder2;
      second.setAttribute('data-saleskitbb05-namepatch-2', '');
      second.style.display = 'none';
      second.style.marginTop = '8px';
      firstInput.parentNode.insertBefore(second, firstInput.nextSibling);
      // Uppercase + 12-char enforcement
      second.addEventListener('input', function () {
        var v = (second.value || '').toUpperCase().slice(0, 12);
        if (v !== second.value) second.value = v;
        applyAddonToDisplay();
      });
    })();

    // Card with checkbox + label + price. Injected once, hidden by default.
    // Shown only when pack = No-Pull Harness.
    var BB05_ADDON_CARD = {
      checkboxLabel: 'Add embroidered name patch',
      priceText:     '+A$14.90'
    };

    (function ensureAddonCard() {
      var firstInput = $('[data-saleskitbb05-namepatch]', scope);
      if (!firstInput) return;
      if ($('[data-saleskitbb05-np-addon-card]', scope)) return;
      var card = document.createElement('label');
      card.className = 'saleskitbb05-namepatch__addon-card';
      card.setAttribute('data-saleskitbb05-np-addon-card', '');
      card.setAttribute('hidden', '');
      card.innerHTML =
        '<input type="checkbox" data-saleskitbb05-np-addon-check>' +
        '<span class="saleskitbb05-namepatch__addon-text">' + BB05_ADDON_CARD.checkboxLabel + '</span>' +
        '<span class="saleskitbb05-namepatch__addon-price">' + BB05_ADDON_CARD.priceText + '</span>';
      // Insert BEFORE the input
      firstInput.parentNode.insertBefore(card, firstInput);
      // Wire change → toggle visible class + refresh price/badge
      var check = card.querySelector('input[type="checkbox"]');
      check.addEventListener('change', function () {
        if (check.checked) card.classList.add('is-checked');
        else card.classList.remove('is-checked');
        if (typeof refreshNamePatchAddonCard === 'function') refreshNamePatchAddonCard();
        if (typeof applyAddonToDisplay === 'function') applyAddonToDisplay();
      });
    })();

    function refreshNamePatchAddonCard() {
      var card = $('[data-saleskitbb05-np-addon-card]', scope);
      var input = $('[data-saleskitbb05-namepatch]', scope);
      var meta = $('.saleskitbb05-namepatch__meta', scope);
      if (!card || !input) return;
      var packKey = optNameStrings.find(function (n) { return /pack/i.test(n); }) || optNameStrings[0];
      var currentPack = (selected[packKey] || '').toLowerCase();
      var trigger = (BB05_NAMEPATCH_BADGE.addonPack || '').toLowerCase();
      var isAddon = currentPack === trigger;
      var check = $('[data-saleskitbb05-np-addon-check]', scope);
      var checked = !!(check && check.checked);

      if (isAddon) {
        card.removeAttribute('hidden');
        card.style.display = '';
        if (checked) {
          input.style.display = '';
          if (meta) meta.style.display = '';
        } else {
          input.style.display = 'none';
          if (meta) meta.style.display = 'none';
          input.value = '';
        }
      } else {
        card.setAttribute('hidden', '');
        card.style.display = 'none';  // belt-and-braces
        if (check) check.checked = false;
        card.classList.remove('is-checked');
        input.style.display = '';
        if (meta) meta.style.display = '';
      }
    }

    function refreshNamePatchTwin() {
      var firstInput = $('[data-saleskitbb05-namepatch]', scope);
      var second = $('[data-saleskitbb05-namepatch-2]', scope);
      if (!firstInput || !second) return;
      var packKey = optNameStrings.find(function (n) { return /pack/i.test(n); }) || optNameStrings[0];
      var currentPack = (selected[packKey] || '').toLowerCase();
      var isTwin = currentPack === BB05_TWIN.pack.toLowerCase();
      if (isTwin) {
        firstInput.placeholder = BB05_TWIN.placeholder1;
        second.style.display = '';
      } else {
        firstInput.placeholder = "Type your pup's name…";
        second.style.display = 'none';
        second.value = '';  // clear second when not twin
      }
    }

    function addonPriceDelta() {
      var badge = $('.saleskitbb05-namepatch__included', scope);
      if (!badge || !badge.classList.contains('is-addon')) return 0;
      // Require the checkbox to be CHECKED on the addon card (No-Pull pack only)
      var check = $('[data-saleskitbb05-np-addon-check]', scope);
      if (!check || !check.checked) return 0;
      return BB05_NAMEPATCH_ADDON.cents;
    }

    function applyAddonToDisplay() {
      if (!currentVariant) return;
      var delta = addonPriceDelta();
      var total = (currentVariant.price || 0) + delta;
      var priceNow = $('[data-saleskitbb05-price-now]', scope);
      if (priceNow) priceNow.textContent = formatMoneyCents(total, currency);
      var ctaEl = $('[data-saleskitbb05-cta]', scope);
      if (ctaEl) {
        var label = ctaEl.dataset.saleskitbb05CtaLabel || 'Add to cart';
        var ok = !!currentVariant.available;
        ctaEl.textContent = (ok ? label : 'Sold out') + (ok ? ' — ' + formatMoneyCents(total, currency) : '');
      }
    }

    function refreshNamePatchBadge() {
      var badge = $('.saleskitbb05-namepatch__included', scope);
      if (!badge) return;
      var packKey = optNameStrings.find(function (n) { return /pack/i.test(n); }) || optNameStrings[0];
      var currentPack = (selected[packKey] || '').toLowerCase();
      var trigger = BB05_NAMEPATCH_BADGE.addonPack.toLowerCase();
      if (currentPack === trigger) {
        badge.textContent = BB05_NAMEPATCH_BADGE.addonText;
        badge.classList.add('is-addon');
      } else {
        badge.textContent = BB05_NAMEPATCH_BADGE.includedText;
        badge.classList.remove('is-addon');
      }
    }

    // Each pack card shows the price for {Pack: that pack value, Color: selected, Size: selected}.
    // Whenever Color or Size changes, every pack card's price + save text gets re-computed live.
    function refreshPackCardsPrices() {
      if (!variants.length) return;
      var packKey = optNameStrings.find(function (n) { return /pack/i.test(n); });
      if (!packKey) return;
      var packIdx = optNameStrings.indexOf(packKey);

      var packBtns = $$('[data-saleskitbb05-option="' + packKey + '"]', scope);
      if (!packBtns.length) return;

      packBtns.forEach(function (btn) {
        var packValue = btn.dataset.saleskitbb05Value;
        if (!packValue) return;

        // Find variant for this pack with the currently-selected other options
        var targetVariant = variants.find(function (v) {
          for (var i = 0; i < optNameStrings.length; i++) {
            var expected = (i === packIdx) ? packValue : selected[optNameStrings[i]];
            if (v.options[i] !== expected) return false;
          }
          return true;
        });

        // Fallback: any variant of this pack (first available, else first)
        if (!targetVariant) {
          targetVariant = variants.find(function (v) { return v.options[packIdx] === packValue && v.available; })
            || variants.find(function (v) { return v.options[packIdx] === packValue; });
        }
        if (!targetVariant) return;

        // Update price text
        var priceEl = btn.querySelector('.saleskitbb05-pack__price');
        if (priceEl) priceEl.textContent = formatMoneyCents(targetVariant.price, currency);

        // Update save text — "Save A$XX" if compare > price, else hide
        var saveEl = btn.querySelector('.saleskitbb05-pack__save');
        if (saveEl) {
          if (targetVariant.compare_at_price && targetVariant.compare_at_price > targetVariant.price) {
            var savedCents = targetVariant.compare_at_price - targetVariant.price;
            saveEl.textContent = 'Save ' + formatMoneyCents(savedCents, currency);
            saveEl.style.display = '';
          } else {
            saveEl.style.display = 'none';
          }
        }
      });
    }

    function refreshSizesVisibility() {
      // Find the sizes wrapper. With OLD Liquid it has no data-attrs — locate by class.
      var sizesWrap = $('[data-saleskitbb05-sizes]', scope) || $('.saleskitbb05-sizes', scope);
      if (!sizesWrap) return;

      // Read config from data attributes; fall back to hardcoded defaults (Twin Pack hides XS)
      // when Liquid section hasn't synced yet.
      var trigger = (sizesWrap.dataset.saleskitbb05HideTrigger || 'Twin Pack').trim().toLowerCase();
      var hideList = (sizesWrap.dataset.saleskitbb05HideSizes || 'XS')
        .split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);

      if (!trigger || !hideList.length) return;

      // Identify current pack value (option named /pack/i, else first option)
      var currentPack = '';
      var packKey = optNameStrings.find(function (n) { return /pack/i.test(n); });
      if (packKey) currentPack = (selected[packKey] || '').toLowerCase();
      else if (optNameStrings.length) currentPack = (selected[optNameStrings[0]] || '').toLowerCase();

      var shouldHide = currentPack === trigger;

      var sizeBtns = $$('[data-saleskitbb05-option]', sizesWrap).filter(function (b) {
        // Only the buttons inside the sizes wrapper (avoid hitting other groups)
        return sizesWrap.contains(b);
      });

      // Identify which option name this group uses (read from any button)
      var sizeKey = sizeBtns.length ? sizeBtns[0].dataset.saleskitbb05Option : null;
      var firstVisibleValue = null;
      var hidSelected = false;

      sizeBtns.forEach(function (btn) {
        var val = (btn.dataset.saleskitbb05Value || '').toLowerCase();
        var inHideList = hideList.indexOf(val) >= 0;
        if (shouldHide && inHideList) {
          btn.style.display = 'none';
          btn.setAttribute('aria-hidden', 'true');
          // If currently active, mark to switch
          if (btn.classList.contains('is-active')) hidSelected = true;
        } else {
          btn.style.display = '';
          btn.removeAttribute('aria-hidden');
          if (!firstVisibleValue) firstVisibleValue = btn.dataset.saleskitbb05Value;
        }
      });

      // If the currently selected size is hidden → switch to first visible
      if (sizeKey && hidSelected && firstVisibleValue && firstVisibleValue.toLowerCase() !== (selected[sizeKey] || '').toLowerCase()) {
        selected[sizeKey] = firstVisibleValue;
        updateActive(sizeKey, firstVisibleValue);
        // Re-resolve variant + price WITHOUT recursing into refreshSizesVisibility infinitely
        currentVariant = findVariantBySelection();
        // Mirror the price/image updates without calling the full refreshCta (avoid loop)
        if (currentVariant) {
          var pn = $('[data-saleskitbb05-price-now]', scope);
          if (pn) pn.textContent = formatMoneyCents(currentVariant.price, currency);
          var cta = $('[data-saleskitbb05-cta]', scope);
          if (cta) {
            cta.dataset.saleskitbb05VariantId = String(currentVariant.id);
            var label = cta.dataset.saleskitbb05CtaLabel || 'Add to cart';
            cta.textContent = (currentVariant.available ? label : 'Sold out') + (currentVariant.available ? ' — ' + formatMoneyCents(currentVariant.price, currency) : '');
          }
        }
      }
    }

    function refreshNamepatchMode() {
      var npBlock = $('[data-saleskitbb05-namepatch-block]', scope);
      if (!npBlock) return;
      var trigger = (npBlock.dataset.saleskitbb05AddonTrigger || '').trim().toLowerCase();
      if (!trigger) return;

      var currentPack = '';
      var packKey = optNameStrings.find(function (n) { return /pack/i.test(n); });
      if (packKey) currentPack = (selected[packKey] || '').toLowerCase();
      else if (optNameStrings.length) currentPack = (selected[optNameStrings[0]] || '').toLowerCase();

      var isAddon = currentPack === trigger;
      var included = $('[data-saleskitbb05-np-included]', scope);
      var addonBadge = $('[data-saleskitbb05-np-addon-badge]', scope);
      var addonCard = $('[data-saleskitbb05-np-addon-card]', scope);
      var input = $('[data-saleskitbb05-namepatch]', scope);
      var meta = $('.saleskitbb05-namepatch__meta', scope);
      var check = $('[data-saleskitbb05-np-addon-check]', scope);

      if (isAddon) {
        if (included) included.setAttribute('hidden', '');
        if (addonBadge) addonBadge.removeAttribute('hidden');
        if (addonCard) addonCard.removeAttribute('hidden');
        var checked = !!(check && check.checked);
        if (input) input.style.display = checked ? '' : 'none';
        if (meta) meta.style.display = checked ? '' : 'none';
        npBlock.classList.add('is-addon-mode');
        if (!checked) npBlock.classList.remove('is-addon-checked');
      } else {
        if (included) included.removeAttribute('hidden');
        if (addonBadge) addonBadge.setAttribute('hidden', '');
        if (addonCard) addonCard.setAttribute('hidden', '');
        if (input) input.style.display = '';
        if (meta) meta.style.display = '';
        npBlock.classList.remove('is-addon-mode', 'is-addon-checked');
      }
    }

    // ---- Defensive: ensure the price-discount span exists & is unique (handles stale Liquid) ----

    (function ensureDiscountSpan() {
      var priceRow = $('.saleskitbb05-info__price-row', scope);
      if (!priceRow) return;

      // Collect EVERY existing discount-like element in the price row
      var allDisc = Array.prototype.slice.call(
        priceRow.querySelectorAll('[data-saleskitbb05-discount], .saleskitbb05-info__price-discount')
      );

      var keep = null;
      if (allDisc.length) {
        // Prefer one that already has the data attribute; otherwise the first
        keep = allDisc.find(function (el) { return el.hasAttribute('data-saleskitbb05-discount'); }) || allDisc[0];
        // Make sure it carries the data attributes the JS expects
        if (!keep.hasAttribute('data-saleskitbb05-discount')) keep.setAttribute('data-saleskitbb05-discount', '');
        if (!keep.getAttribute('data-saleskitbb05-discount-prefix')) keep.setAttribute('data-saleskitbb05-discount-prefix', 'SAVE');
        // Remove every other duplicate
        allDisc.forEach(function (el) { if (el !== keep) el.parentNode && el.parentNode.removeChild(el); });
      } else {
        // No span anywhere — create one
        keep = document.createElement('span');
        keep.className = 'saleskitbb05-info__price-discount';
        keep.setAttribute('data-saleskitbb05-discount', '');
        keep.setAttribute('data-saleskitbb05-discount-prefix', 'SAVE');
        keep.style.display = 'none';
        priceRow.appendChild(keep);
      }
    })();

    // ---- Wire option buttons — use DELEGATED handler so it works for ALL option groups
    // regardless of name (Pack/Colour/Color/Size/etc.) and for dynamically rendered swatches.
    scope.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-saleskitbb05-option]');
      if (!btn || !scope.contains(btn)) return;
      var group = btn.dataset.saleskitbb05Option;
      var value = btn.dataset.saleskitbb05Value;
      if (!group || !value) return;
      // Avoid double-handling for buttons inside form elements
      ev.preventDefault();
      selected[group] = value;
      updateActive(group, value);
      refreshCta();
    });

    // ---- Add-on checkbox toggle (name patch) -----------------------
    var npAddonCheck = $('[data-saleskitbb05-np-addon-check]', scope);
    if (npAddonCheck) {
      npAddonCheck.addEventListener('change', function () {
        var npBlock = $('[data-saleskitbb05-namepatch-block]', scope);
        if (npAddonCheck.checked) {
          if (npBlock) npBlock.classList.add('is-addon-checked');
        } else {
          if (npBlock) npBlock.classList.remove('is-addon-checked');
        }
        refreshNamepatchMode();
      });
    }

    // ---- Live cart count sync (BB05 header) ----------------------
    // Updates every [data-saleskitbb05-cart-count] span instantly when:
    //   1. Any /cart/* fetch resolves (intercepted globally)
    //   2. Any known cart event fires (Dawn, UPCART, Bold, Rebuy, Shopify PubSub)
    //   3. Page visibility changes back (user returns to tab)
    //   4. Fallback poll every 4s while page is visible
    function syncBB05CartFromShopify() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;
          document.querySelectorAll('[data-saleskitbb05-cart-count]').forEach(function (el) {
            if (el.textContent !== String(count)) el.textContent = String(count);
          });
          // Subtle pulse on the BB05 cart link to draw attention
          document.querySelectorAll('[data-saleskitbb05-cart-link]').forEach(function (el) {
            el.classList.add('is-cart-pulse');
            setTimeout(function () { el.classList.remove('is-cart-pulse'); }, 600);
          });
        })
        .catch(function () {});
    }

    // 1) Intercept ALL fetch calls to /cart/* and refresh after they finish.
    //    This catches UPCART, Bold, Rebuy, Dawn drawer, native Shopify, and any other
    //    app that mutates the cart via the Storefront Cart API.
    if (!window.__bb05CartFetchHooked) {
      window.__bb05CartFetchHooked = true;
      var origFetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        var url = (args[0] && args[0].url) || args[0] || '';
        var promise = origFetch.apply(this, args);
        if (typeof url === 'string' && /\/cart(?:\/(?:add|change|update|clear)(?:\.js)?)?(?:[?#].*)?$/.test(url)) {
          promise.then(function (r) {
            // small delay so Shopify has finished the write
            setTimeout(syncBB05CartFromShopify, 50);
            return r;
          }).catch(function () {});
        }
        return promise;
      };

      // Also intercept XMLHttpRequest for legacy apps
      var origXhrOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__bb05Url = url;
        return origXhrOpen.apply(this, arguments);
      };
      var origXhrSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        var self = this;
        this.addEventListener('load', function () {
          if (self.__bb05Url && /\/cart(?:\/(?:add|change|update|clear)(?:\.js)?)?/.test(self.__bb05Url)) {
            setTimeout(syncBB05CartFromShopify, 50);
          }
        });
        return origXhrSend.apply(this, arguments);
      };
    }

    // 2) Listen to a wide net of cart events
    var BB05_CART_EVENTS = [
      'cart:refresh', 'cart:updated', 'cart:added', 'cart:open', 'cart:close',
      'cart-update', 'on:cart-update', 'product:cart-added', 'ajaxProduct:added',
      'drawer:open', 'drawer:close', 'cart-drawer:open', 'cart-drawer:close',
      'open-cart-drawer', 'upcart:open', 'upcart:close', 'upcart:cart-updated',
      'bold-cart:updated', 'rebuy:cart-updated'
    ];
    BB05_CART_EVENTS.forEach(function (ev) {
      document.addEventListener(ev, syncBB05CartFromShopify);
      window.addEventListener(ev, syncBB05CartFromShopify);
    });

    // 3) Sync when user returns to the tab
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) syncBB05CartFromShopify();
    });

    // 4) Fallback poll every 4 seconds while page is visible
    if (!window.__bb05CartPoll) {
      window.__bb05CartPoll = setInterval(function () {
        if (!document.hidden) syncBB05CartFromShopify();
      }, 4000);
    }

    // 5) Initial sync once the script is loaded (defensive — page may have been cached)
    syncBB05CartFromShopify();

    // ---- Initial render --------------------------------------------
    optNameStrings.forEach(function (n) {
      if (selected[n]) updateActive(n, selected[n]);
    });
    refreshCta();

    // ---- Name patch input (line item property) ---------------------
    var patchInput = $('[data-saleskitbb05-namepatch]', scope);
    if (patchInput) {
      patchInput.addEventListener('input', function () {
        var v = (patchInput.value || '').toUpperCase().slice(0, 12);
        if (v !== patchInput.value) patchInput.value = v;
        applyAddonToDisplay();
      });
    }

    // ---- ATC click → cart permalink with name-patch property -------
    var cta = $('[data-saleskitbb05-cta]', scope);
    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        if (cta.disabled) return;

        var vid = cta.dataset.saleskitbb05VariantId;
        if (!vid) {
          // No variant resolved — flash the size selector
          var sizes = $('[data-saleskitbb05-sizes]', scope);
          if (sizes) {
            sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
            sizes.style.transition = 'box-shadow 0.4s ease';
            sizes.style.boxShadow = '0 0 0 3px var(--sk-sale)';
            setTimeout(function () { sizes.style.boxShadow = ''; }, 1000);
          }
          return;
        }

        var url = '/cart/' + vid + ':1';
        var props = [];
        if (patchInput && patchInput.value.trim()) {
          props.push('attributes[Name patch]=' + encodeURIComponent(patchInput.value.trim()));
        }
        // Use cart change with properties via /cart/add.js for line-item properties (note attribute scope is cart-level)
        // Simpler & reliable: submit a hidden form
        submitAtcForm(vid, patchInput && patchInput.value.trim());
      });
    }

    function submitAtcForm(variantId, namePatch) {
      // AJAX add to cart, then open the theme drawer
      var formData = { 'items': [ { 'id': Number(variantId), 'quantity': 1 } ] };

      var npBlock = $('[data-saleskitbb05-namepatch-block]', scope);
      var isAddonMode = npBlock && npBlock.classList.contains('is-addon-mode');
      var addonChecked = npBlock && npBlock.classList.contains('is-addon-checked');
      var addonVariantId = npBlock && npBlock.dataset.saleskitbb05AddonVariant;

      // ----- Name patch attaching strategy -----
      var badgeEl = $('.saleskitbb05-namepatch__included', scope);
      var isPaidAddon = badgeEl && badgeEl.classList.contains('is-addon');
      var addonVid = (BB05_NAMEPATCH_ADDON && BB05_NAMEPATCH_ADDON.addonVariantId) || '';
      var checkEl = $('[data-saleskitbb05-np-addon-check]', scope);
      var addonChecked = !!(checkEl && checkEl.checked);

      // Detect Twin Pack — 2 inputs
      var packKey2 = optNameStrings.find(function (n) { return /pack/i.test(n); }) || optNameStrings[0];
      var currentPackSubmit = (selected[packKey2] || '').toLowerCase();
      var isTwinSubmit = currentPackSubmit === (BB05_TWIN.pack || '').toLowerCase();

      if (isTwinSubmit) {
        var twin1Val = (patchInput && patchInput.value.trim()) || '';
        var twin2El = $('[data-saleskitbb05-namepatch-2]', scope);
        var twin2Val = (twin2El && twin2El.value.trim()) || '';
        var twinProps = {};
        if (twin1Val) twinProps['Name patch 1'] = twin1Val;
        if (twin2Val) twinProps['Name patch 2'] = twin2Val;
        if (Object.keys(twinProps).length) formData.items[0].properties = twinProps;
      } else if (isPaidAddon) {
        // No-Pull Harness — addon mode. Only attach if checkbox is ticked AND name typed.
        if (addonChecked && namePatch) {
          if (addonVid) {
            var addonItem = { id: Number(addonVid), quantity: 1 };
            addonItem.properties = { 'Name patch': namePatch };
            formData.items.push(addonItem);
          } else {
            formData.items[0].properties = { 'Name patch': namePatch };
          }
        }
        // If unchecked or no name → no name patch attached
      } else {
        // Walk Kit (single included)
        if (namePatch) formData.items[0].properties = { 'Name patch': namePatch };
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(formData)
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // Update cart count badges in the header (fetch fresh state from /cart.js)
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var countEls = document.querySelectorAll(
            '[data-saleskitbb05-cart-count], ' +
            '.cart-count-bubble span:first-child, .cart-count, .cart-icon-bubble [data-cart-count], ' +
            '[data-cart-item-count], .header__cart-count, .site-header__cart-count'
          );
          countEls.forEach(function (el) { el.textContent = String(cart.item_count || 0); });

          // Also broadcast a "Cart updated" pulse on the BB05 header link
          var bb05CartLinks = document.querySelectorAll('[data-saleskitbb05-cart-link]');
          bb05CartLinks.forEach(function (el) {
            el.classList.add('is-cart-pulse');
            setTimeout(function () { el.classList.remove('is-cart-pulse'); }, 600);
          });
          // Also broadcast cart state
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart, bubbles: true }));
        }).catch(function () {});

        // Fire common drawer-open events (Dawn, UPCART, RebuyEngine, Slide Cart, Bond, GemPages, etc.)
        var events = ['cart:open', 'cart:added', 'ajaxProduct:added',
          'cart-drawer:open', 'open-cart-drawer', 'product:cart-added', 'cart:updated',
          'drawer:open', 'on:cart-update'];
        events.forEach(function (ev) {
          document.dispatchEvent(new CustomEvent(ev, { detail: data, bubbles: true }));
        });
        // PubSub style (Dawn 9+)
        if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
          try { window.publish('cart-update', { source: 'saleskitbb05', cart: data }); } catch (e) {}
        }

        // Try clicking common drawer triggers (visible ones first)
        var triggerSelectors = [
          '[data-cart-drawer-trigger]', '[data-drawer-cart]', '.js-cart-drawer-open',
          '[aria-controls="cart-drawer"]', '[aria-controls="CartDrawer"]',
          '.header__cart-link', '.cart-icon-bubble', 'a.cart-link', '#cart-icon-bubble',
          '.site-header__cart', '.header__icon--cart', '[href="/cart"]',
          '.upcart-icon', '#upcart-cart-icon', '[data-rebuy-cart-toggle]'
        ];
        for (var s = 0; s < triggerSelectors.length; s++) {
          var nodes = document.querySelectorAll(triggerSelectors[s]);
          for (var i = 0; i < nodes.length; i++) {
            var t = nodes[i];
            var rect = t.getBoundingClientRect();
            if (rect.width > 0 && rect.height > 0) { t.click(); return; }
          }
        }
        // No redirect — item is already in cart, drawer attempts done. User sees badge update.
      })
      .catch(function () {
        // If fetch fails, fall back to native form submit
        var f = document.createElement('form');
        f.method = 'post'; f.action = '/cart/add'; f.style.display = 'none';
        var i = document.createElement('input'); i.name = 'id'; i.value = variantId; f.appendChild(i);
        var q = document.createElement('input'); q.name = 'quantity'; q.value = '1'; f.appendChild(q);
        if (namePatch) {
          var p = document.createElement('input'); p.name = 'properties[Name patch]'; p.value = namePatch; f.appendChild(p);
        }
        document.body.appendChild(f); f.submit();
      });
    }
  }

  // ---- Gallery thumbs (works without product wiring) -----------------
  function initGallery(scope) {
    var thumbs = $$('.saleskitbb05-gallery__thumb', scope);
    var mainWrap = $('.saleskitbb05-gallery__main', scope);
    var mainImg = $('.saleskitbb05-gallery__main img', scope);
    var prevBtn = $('.saleskitbb05-gallery__nav--prev', scope);
    var nextBtn = $('.saleskitbb05-gallery__nav--next', scope);
    if (!thumbs.length || !mainImg || !mainWrap) return;

    // Collect all slide sources from thumbs
    var slides = thumbs.map(function (t) {
      return t.dataset.saleskitbb05Src || (t.querySelector('img') && t.querySelector('img').src) || '';
    }).filter(function (s) { return !!s; });

    var current = 0;

    // Counter pill
    var counter = document.createElement('div');
    counter.className = 'saleskitbb05-gallery__counter';
    mainWrap.appendChild(counter);
    function updateCounter() {
      counter.textContent = (current + 1) + ' / ' + slides.length;
    }

    function goTo(idx) {
      if (!slides.length) return;
      // wrap around
      if (idx < 0) idx = slides.length - 1;
      if (idx >= slides.length) idx = 0;
      current = idx;
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      // Smooth fade transition
      mainImg.style.opacity = '0';
      setTimeout(function () {
        mainImg.src = slides[idx];
        mainImg.style.opacity = '1';
      }, 120);
      updateCounter();
      // Horizontal-only scroll on the thumbs strip (NEVER vertical)
      var thumbsCont2 = $('.saleskitbb05-gallery__thumbs', scope);
      var active = thumbs[idx];
      if (thumbsCont2 && active) {
        var bRect = active.getBoundingClientRect();
        var cRect = thumbsCont2.getBoundingClientRect();
        var dx = (bRect.left - cRect.left) - (cRect.width - bRect.width) / 2;
        thumbsCont2.scrollTo({ left: thumbsCont2.scrollLeft + dx, behavior: 'smooth' });
      }
    }

    // Thumb click
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        goTo(i);
      });
    });

    // Prev / Next buttons
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); goTo(current + 1); });

    // Keyboard navigation when scope is in viewport
    document.addEventListener('keydown', function (e) {
      var rect = mainWrap.getBoundingClientRect();
      var inView = rect.top < window.innerHeight && rect.bottom > 0;
      if (!inView) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });

    // Touch swipe support
    var touchStartX = 0;
    var touchStartY = 0;
    var touching = false;
    mainWrap.addEventListener('touchstart', function (e) {
      if (!e.touches.length) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touching = true;
    }, { passive: true });
    mainWrap.addEventListener('touchmove', function (e) {
      if (!touching || !e.touches.length) return;
      var dx = Math.abs(e.touches[0].clientX - touchStartX);
      var dy = Math.abs(e.touches[0].clientY - touchStartY);
      // If horizontal intent, prevent default vertical scroll
      if (dx > 12 && dx > dy) e.preventDefault();
    }, { passive: false });
    mainWrap.addEventListener('touchend', function (e) {
      if (!touching) return;
      touching = false;
      var endX = (e.changedTouches[0] || {}).clientX || touchStartX;
      var diff = endX - touchStartX;
      if (Math.abs(diff) > 40) {
        if (diff < 0) goTo(current + 1);
        else goTo(current - 1);
      }
    }, { passive: true });

    // Lightbox / zoom disabled by user request

    // Smooth fade-in baseline
    mainImg.style.transition = 'opacity 0.18s ease';
    updateCounter();
  }

  // ---- Lightbox -------------------------------------------------------
  function openLightbox(scope, slides, startIdx, goToInGallery) {
    var overlay = document.createElement('div');
    overlay.className = 'saleskitbb05-lightbox';
    overlay.innerHTML = ''
      + '<button class="saleskitbb05-lightbox__close" aria-label="Close">×</button>'
      + '<button class="saleskitbb05-lightbox__nav saleskitbb05-lightbox__nav--prev" aria-label="Previous">←</button>'
      + '<button class="saleskitbb05-lightbox__nav saleskitbb05-lightbox__nav--next" aria-label="Next">→</button>'
      + '<img class="saleskitbb05-lightbox__img" src="' + slides[startIdx] + '" alt="">'
      + '<div class="saleskitbb05-lightbox__counter"></div>';
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    var img = overlay.querySelector('.saleskitbb05-lightbox__img');
    var counter = overlay.querySelector('.saleskitbb05-lightbox__counter');
    var idx = startIdx;

    function render() {
      img.src = slides[idx];
      counter.textContent = (idx + 1) + ' / ' + slides.length;
      goToInGallery(idx);
    }
    render();

    function close() {
      overlay.remove();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') { idx = (idx - 1 + slides.length) % slides.length; render(); }
      if (e.key === 'ArrowRight') { idx = (idx + 1) % slides.length; render(); }
    }
    overlay.querySelector('.saleskitbb05-lightbox__close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelector('.saleskitbb05-lightbox__nav--prev').addEventListener('click', function () {
      idx = (idx - 1 + slides.length) % slides.length; render();
    });
    overlay.querySelector('.saleskitbb05-lightbox__nav--next').addEventListener('click', function () {
      idx = (idx + 1) % slides.length; render();
    });
    document.addEventListener('keydown', onKey);
  }

  // ---- Accordions -----------------------------------------------------
  function initAccordions(scope) {
    $$('.saleskitbb05-accordion__header', scope).forEach(function (header) {
      header.addEventListener('click', function () {
        var content = header.nextElementSibling;
        var icon = header.querySelector('.saleskitbb05-accordion__icon');
        if (!content) return;
        content.classList.toggle('is-open');
        if (icon) icon.textContent = content.classList.contains('is-open') ? '−' : '+';
      });
    });

    // Helper links that open a specific accordion by keyword match
    $$('[data-saleskitbb05-open-accordion]', scope).forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var keyword = (link.dataset.accordionKeyword || link.dataset.saleskitbb05OpenAccordion || '').toLowerCase();
        if (!keyword) return;
        var headers = $$('.saleskitbb05-accordion__header', scope);
        var match = null;
        headers.forEach(function (h) {
          if (!match && (h.textContent || '').toLowerCase().indexOf(keyword) !== -1) match = h;
        });
        if (!match) return;
        var content = match.nextElementSibling;
        var icon = match.querySelector('.saleskitbb05-accordion__icon');
        if (content && !content.classList.contains('is-open')) {
          content.classList.add('is-open');
          if (icon) icon.textContent = '−';
        }
        // Smooth scroll into view
        match.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // ---- Scroll-to-top CTAs (text-cta sections) -------------------------
  function initScrollTopCtas() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-saleskitbb05-scroll-top]');
      if (!link) return;
      e.preventDefault();
      // Find the PDP master section in the page — scroll to its top
      var pdp = document.querySelector('.saleskitbb05-pdp');
      if (pdp) {
        var top = pdp.getBoundingClientRect().top + window.pageYOffset - 24;
        window.scrollTo({ top: top, behavior: 'smooth' });
      } else {
        // Fallback: scroll to page top
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  // ---- Smooth scroll for in-scope anchors -----------------------------
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.saleskitbb05-scope a[href^="#"]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href === '#') return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  ready(function () {
    $$('.saleskitbb05-scope').forEach(function (scope) {
      initPdp(scope);
      initGallery(scope);
      initAccordions(scope);
    });
    initSmoothScroll();
    initScrollTopCtas();
  });
})();
